module.exports = __webpack_public_path__ + "static/media/87.df087c44.jpg";